import COLORS from '@styles/colors/themes/beam/beam2';
import { Mutable } from '@styles/colors/themes/beam/types';

const TYPOGRAPHY = {
  headings: {
    h900: {
      fontWeight: 600,
      fontSize: 32,
      /** = 40 / 32 */
      lineHeight: 1.25,
      color: COLORS.neutral.n901,
    },
    h800: {
      fontWeight: 600,
      fontSize: 24,
      /** = 32 / 24 */
      lineHeight: 1.3333333333333333,
      color: COLORS.neutral.n901,
    },
    h700: {
      fontWeight: 600,
      fontSize: 20,
      /** = 24 / 20 */
      lineHeight: 1.2,
      color: COLORS.neutral.n901,
    },
    h600: {
      fontWeight: 600,
      fontSize: 18,
      /** = 24 / 18 */
      lineHeight: 1.3333333333333333,
      color: COLORS.neutral.n901,
    },
    h500: {
      fontWeight: 600,
      fontSize: 16,
      /** = 24 / 16 */
      lineHeight: 1.5,
      color: COLORS.neutral.n901,
    },
    h400: {
      fontWeight: 500,
      fontSize: 14,
      /** = 22 / 14 */
      lineHeight: 1.5714285714285714,
      color: COLORS.neutral.n901,
    },
    h300: {
      fontWeight: 500,
      fontSize: 12,
      /** = 18 / 12 */
      lineHeight: 1.5,
      color: COLORS.neutral.n901,
    },
    h200: {
      fontWeight: 600,
      fontSize: 12,
      /** = 18 / 12 */
      lineHeight: 1.5,
      color: COLORS.neutral.n800,
    },
    h100: {
      fontWeight: 500,
      fontSize: 10,
      /** = 16 / 10 */
      lineHeight: 1.6,
      color: COLORS.neutral.n800,
    },
  },
  paragraph: {
    p300: {
      fontWeight: 400,
      fontSize: 16,
      /** = 24 / 16 */
      lineHeight: 1.5,
      color: COLORS.neutral.n800,
    },
    p200: {
      fontWeight: 400,
      fontSize: 14,
      /** = 22 / 14 */
      lineHeight: 1.5714285714285714,
      color: COLORS.neutral.n800,
    },
    p100: {
      fontWeight: 400,
      fontSize: 12,
      /** = 18 / 12 */
      lineHeight: 1.5,
      color: COLORS.neutral.n800,
    },
  },
  paragraphLight: {
    pl300: {
      fontWeight: 300,
      fontSize: 16,
      /** = 24 / 16 */
      lineHeight: 1.5,
      color: COLORS.neutral.n800,
    },
    pl200: {
      fontWeight: 300,
      fontSize: 14,
      /** = 22 / 14 */
      lineHeight: 1.5714285714285714,
      color: COLORS.neutral.n800,
    },
    pl100: {
      fontWeight: 300,
      fontSize: 12,
      /** = 18 / 12 */
      lineHeight: 1.5,
      color: COLORS.neutral.n800,
    },
  },
  buttons: {
    /** Same as h400, different color */
    b200: {
      fontWeight: 500,
      fontSize: 14,
      /** = 22 / 14 */
      lineHeight: 1.5714285714285714,
      color: COLORS.neutral.n800,
    },
  },
  code: {
    cd200: {
      fontWeight: 400,
      fontSize: 14,
      /** = 16 / 14 */
      lineHeight: 1.1428571428571428,
      color: COLORS.blue.b600,
    },
  },
} as const; // Note: This doesn't have to be const. It is just  for ease.
type T_TYPOGRAPHY = Mutable<typeof TYPOGRAPHY>;

export type { T_TYPOGRAPHY };
export default TYPOGRAPHY as T_TYPOGRAPHY;
